import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/login/Login.vue";
import Exceptions from "../components/dashboard/Exceptions.vue";
import FirmManager from "../components/firmmanager/FirmManager.vue";
import LicenseManager from "../components/licensemanager/LicenseManager.vue";
import SettingsManager from "../components/settingsmanager/SettingsManager.vue";
import UsageManager from "../components/usagemanager/UsageManager.vue";
import UserManager from "../components/usermanager/UserManager.vue";

Vue.use(VueRouter);

const routes = [
    { path: "/", name: "login", component: Login },
    { path: "/firms", name: "firms", component: FirmManager },
    { path: "/exceptions", name: "exceptions", component: Exceptions },
    { path: "/licenses", name: "licenses", component: LicenseManager },
    { path: "/settings", name: "settings", component: SettingsManager },
    { path: "/usage", name: "usage", component: UsageManager },
    { path: "/users", name: "users", component: UserManager },
];

const router = new VueRouter({
    mode: "history",
    base: "/cm/",
    routes,
});

export default router;
